import SEOHead from '../components/SEOHead';

const CONTACT_EMAIL = 'optionview580@gmail.com';
const LAST_UPDATED = 'March 4, 2026';

const H2 = 'text-xl font-semibold text-neutral-900 dark:text-neutral-100 mb-2';
const LINK = 'text-primary-600 dark:text-primary-400 hover:underline';

export default function Disclaimer() {
  return (
    <>
      <SEOHead
        title="Disclaimer"
        description="Important disclaimer for OptionView — this tool is for informational purposes only and does not constitute financial advice."
        canonicalPath="/disclaimer"
      />

      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10">
        <h1 className="text-3xl font-bold text-neutral-900 dark:text-neutral-100 mb-2">Disclaimer</h1>
        <p className="text-sm text-neutral-500 dark:text-neutral-400 mb-8">Last updated: {LAST_UPDATED}</p>

        <div className="mb-6 p-4 bg-orange-50/80 dark:bg-orange-900/20 border border-orange-200/60 dark:border-orange-800/60 rounded-clay text-sm text-orange-800 dark:text-orange-300 font-semibold">
          <svg className="inline-block w-4 h-4 mr-1.5 shrink-0 align-text-bottom" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
          </svg>
          Important: Please read this disclaimer carefully before using OptionView.
        </div>

        <div className="bg-surface border border-surface rounded-clay shadow-clay dark:shadow-clay-dark backdrop-blur-sm p-6 sm:p-8 space-y-6 text-sm text-neutral-700 dark:text-neutral-300 leading-relaxed">

          <section>
            <h2 className={H2}>Not Financial Advice</h2>
            <p className="mb-2">
              <strong>
                The information provided on optionview.in is for informational and educational
                purposes only. It does not constitute financial advice, investment advice,
                trading advice, or any other type of advice.
              </strong>
            </p>
            <p>
              Option View is <strong>not a SEBI-registered investment advisor</strong>, research
              analyst, or portfolio manager. Nothing on this website should be construed as a
              recommendation to buy, sell, or hold any security, option, or financial instrument.
              Always consult a SEBI-registered financial advisor or investment advisor before
              making any trading or investment decisions.
            </p>
          </section>

          <section>
            <h2 className={H2}>Risk Warning</h2>
            <p className="mb-2">
              <strong>Options trading and derivatives trading involve substantial risk of loss
              and are not suitable for all investors.</strong>
            </p>
            <ul className="list-disc pl-5 space-y-1">
              <li>You can lose your <strong>entire invested capital</strong> in options trading</li>
              <li>Options are leveraged instruments — small price moves can result in large losses</li>
              <li>Only trade with money you can afford to lose completely</li>
              <li>Past performance of any strategy, instrument, or indicator does not guarantee future results</li>
              <li>IV Rank and IV Percentile are analytical tools, not trading signals</li>
            </ul>
          </section>

          <section>
            <h2 className={H2}>Data Accuracy</h2>
            <p className="mb-2">
              Data displayed on OptionView is sourced from different, free and publicly available data sources.
              While we strive for accuracy in processing and presenting this data:
            </p>
            <ul className="list-disc pl-5 space-y-1 mb-2">
              <li>We <strong>cannot guarantee</strong> that the data is always accurate, complete, or up to date</li>
              <li>Data may be delayed — it is end-of-day data from the previous trading session</li>
              <li>Occasional errors in NSE source data may be reflected on this site</li>
              <li>IV calculations are based on mathematical models (Black-Scholes) which involve assumptions that may not hold in all market conditions</li>
            </ul>
            <p>
              <strong>Please do not use data/inputs from OptionView to make any trading decisions.</strong>
            </p>
          </section>

          <section>
            <h2 className={H2}>No Warranty</h2>
            <p className="mb-2">
              The Service is provided "as is" without any representations or warranties, express
              or implied. We make no representations or warranties about:
            </p>
            <ul className="list-disc pl-5 space-y-1 mb-2">
              <li>The accuracy or completeness of any data or calculations</li>
              <li>The fitness of this tool for any particular purpose</li>
              <li>The uninterrupted availability of the Service</li>
            </ul>
            <p>Use this tool entirely at your own risk.</p>
          </section>

          <section>
            <h2 className={H2}>Affiliate Disclosure</h2>
            <p>
              OptionView may display advertisements via Google AdSense. In the future, we may
              include affiliate links to broker platforms or financial products. Any such
              affiliate relationships will not influence the data or analysis presented on
              this site. We will clearly disclose any affiliate relationships when applicable.
            </p>
          </section>

          <section>
            <h2 className={H2}>External Links</h2>
            <p>
              This website may contain links to external websites such as NSE, SEBI, or other
              financial platforms. These links are provided for convenience and information only.
              We are not responsible for the content, accuracy, or practices of any external
              website and do not endorse them.
            </p>
          </section>

          <section>
            <h2 className={H2}>Updates to This Disclaimer</h2>
            <p>
              This disclaimer may be updated at any time. Check this page regularly for the
              latest version. Continued use of the Service constitutes acceptance of the
              current disclaimer.
            </p>
          </section>

          <section>
            <h2 className={H2}>Contact</h2>
            <p>
              Questions about this disclaimer? Email us at{' '}
              <a href={`mailto:${CONTACT_EMAIL}`} className={LINK}>
                {CONTACT_EMAIL}
              </a>
              .
            </p>
          </section>

        </div>
      </div>
    </>
  );
}
